import React, {useState} from 'react'
import { HiMiniBars3 } from "react-icons/hi2";
import MobileMenu from './MobileMenu';
import {setMenuTrue} from '../../redux/slice/changeState'
import { useSelector, useDispatch } from 'react-redux';

const ToggleMenu = () => {
  const dispatch = useDispatch()
  const toggleMenu = useSelector((state)=> state.toggle)

  

  return (
    <>
       <nav className="mobile-nav">
          <div className="menu-toggle text-end" >
            <HiMiniBars3 size={30} onClick={()=>dispatch(setMenuTrue())} /> 
          </div>
          
        </nav> 
        {toggleMenu.openMenu && <MobileMenu />}
    </>
  )
}

export default ToggleMenu
